import { Http } from '@bizzabo/transport';
import { AxiosInstance } from 'axios';
import config from 'config';
import { getGroupId } from '../';
import { getIsOrganizerToken } from './useOrganizerToken';

const transport = new Http({
    baseUrl: config.baseUrl,
});
const client: () => AxiosInstance = () => {
    // This fix is to allow organizer to avoid setting this token => so default token will be used
    // currently it is used for web partner
    const isAttendeeToken = !getIsOrganizerToken();
    if (isAttendeeToken) {
        transport.setTokenCookieName(`${config.authCookieAccess}-${getGroupId()}`);
        transport.setRefreshTokenUrl(`/token/refresh?eventGroupId=${getGroupId()}`);
    }
    return transport.http(isAttendeeToken);
};

export default client;
